export const useGetSchoolHasBegun = () => {
    const date = new Date();
    const month = date.getMonth();

    return month !== 6 && month !== 7 ? true : false;
}